import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../feature'
import type { Feature } from '../feature'

/** Clears sibling users when the active zone, app, or scenario changes. */
export const clearOnContextChange = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    rxjs
      .combineLatest({
        appContext: meFeature.contexts.selectors.appContext.asObservable,
        scenarioContext:
          meFeature.contexts.selectors.scenarioContext.asObservable,
        zoneContext: meFeature.contexts.selectors.zoneContext.asObservable,
      })
      .pipe(
        rxjs.map(
          ({ appContext, scenarioContext, zoneContext }) =>
            scenarioContext ?? appContext ?? zoneContext,
        ),
        rxjs.distinctUntilChanged(isDeepEqual),
        rxjs.map(() =>
          feature.actions.clear.from('SiblingUsers.Context.Changed').create(),
        ),
      ),
)
